export default __webpack_public_path__ + "static/media/film_2.ea241bf7.mp4";